import { observer } from 'mobx-react-lite'
import { interval } from 'rxjs'
import { useObservableValue } from '@/hooks/rx-hooks'
import { type DraftJobViewModel } from '@/features/jobs/drafting/DraftJobViewModel'
import { Job } from '@/features/jobs/Job'
import {
  Header,
  PersistingStatus,
} from '@/features/jobs/drafting/components/JobCreation/Header'

export interface HeaderContainerProps {
  vm: DraftJobViewModel
}

export const HeaderContainer = observer(function HeaderContainer({
  vm,
}: HeaderContainerProps) {
  return (
    <Header
      isProgressShown={vm.isProgressShown}
      progressPercent={vm.outline.progress.percent}
      backTooltip={vm.backTooltip}
      isBackDisabled={!vm.outline.previousStep}
      onBack={vm.outline.goToPrevious}
      title={vm.title}
      persistingStatus={<PersistingStatusContainer vm={vm} />}
      isActionsMenuShown={vm.job !== Job.none}
      isActionsMenuDisabled={vm.persister.persisting}
      onRename={vm.renameModal.show}
      onClone={vm.copyModal.modal.show}
      onDelete={vm.promptDelete}
    />
  )
})

// Refreshes every minute + 1 second
const refresh$ = interval(61000)

interface PersistingStatusContainerProps {
  vm: DraftJobViewModel
}

const PersistingStatusContainer = observer(function PersistingStatusContainer({
  vm,
}: PersistingStatusContainerProps) {
  useObservableValue(refresh$, { initial: 0 })

  if (vm.persister.persisting) {
    return <PersistingStatus persisting />
  }

  if (vm.persister.lastPersistResult.errorMessage) {
    return (
      <PersistingStatus
        error
        title={vm.persister.lastPersistResult.errorMessage}
      >
        Saving failed
      </PersistingStatus>
    )
  }

  if (!vm.persister.jobWasCreated) {
    return null
  }

  return (
    <PersistingStatus title={vm.lastSavedTitle}>
      {vm.lastSavedLabel}
    </PersistingStatus>
  )
})
